/***
**Module Name: SessionPopup
 **File Name :  SessionPopup.js
 **Project :    Dadi
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  Kiran
 **author :  Mani Kanta
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Mar 29 2023
 **Last modified on:  Mar 29 2023
 **Description : contains category page details.
 ***/
import {  useContext } from "react";

import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { contentContext } from "../context/contentContext";
import tmdbApi from "../api/tmdbApi";

const SessionPopup = (props) => {
    const navigate = useNavigate();

    const {  userData
    } = useContext(contentContext)


    // const handleCloseEnq = () => {
    //     setEnquire(false)
    // };


    const signoutsession = async () => {
        try {
            const response = await tmdbApi.SignOutUser({ emailId: userData.emailid });
            console.log(response);

        } catch {
            console.log("error");
        }
    }

    const onConfirm = () => {
        localStorage.clear();

        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("moduleid");
        localStorage.removeItem("libraryId");
        localStorage.removeItem("ClientName");
        localStorage.removeItem("ClientType");
        localStorage.removeItem('subscriptionPlanId')
        localStorage.clear();
        signoutsession();
        // navigate("/");
        navigate("/login")

    }



    return (

        <>

            <Modal className="access-denied" show={true} >

                <div className="modal-body enquiry-form">
                    <div className="container">
                        <button className="close-btn" onClick={e => onConfirm()}><span className="material-icons">close</span></button>
                        <span className="material-icons access-denied-icon">lock_clock</span>
                        <h3>Session Terminated</h3>
                        <p>
                            {/* The current session has been terminated because some one has logged in another window. */}

                            Your session has been logged out due to inactivity for more than 30 minutes.

                        </p>
                        <div className="popup-footer">
                            <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => onConfirm()}>OK</button>
                        </div>

                    </div>
                </div>

            </Modal>


        </>
    )
}
export default SessionPopup